import { render, staticRenderFns } from "./internationalRoaming.vue?vue&type=template&id=710e00bc&scoped=true&"
import script from "./internationalRoaming.vue?vue&type=script&lang=js&"
export * from "./internationalRoaming.vue?vue&type=script&lang=js&"
import style0 from "./internationalRoaming.vue?vue&type=style&index=0&id=710e00bc&prod&lang=scss&scoped=true&"
import style1 from "./internationalRoaming.vue?vue&type=style&index=1&id=710e00bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e00bc",
  null
  
)

export default component.exports